<template>
  <a-card :bordered="false">
    <custom-page-table
      ref="tableList"
      :queryParams="queryParams"
      :columns="columns"
      base-key="payUrl"
      params-path="commissionRuleOrder/getCommissionRuleOrderList"
    >
    </custom-page-table>
  </a-card>
</template>

<script>
export default {
  name: 'CommissionHelper',
  data() {
    return {
      columns: [
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '规则内容',
          dataIndex: 'ruleOrderValue'
        },
        {
          title: '适用规则名称',
          dataIndex: 'ruleName'
        },
        {
          title: '规则方式',
          dataIndex: 'ruleTypeStr'
        },
        {
          title: '执行时间',
          dataIndex: 'updateTime'
        }
      ],
      queryParams: {}
    }
  },
  created() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'CommissionHelper', title: '佣金分配记录' },
      { name: 'CommissionRule', title: '佣金规则' }
    ])
  }
}
</script>
<style scoped>
</style>
